import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography, Chip } from '@material-ui/core';

// STYLES
import { Container } from './styles';

const SelectedSection = ({ title, data, clickable, onDelete }) => {
  if (!data.length) {
    return null;
  }

  return (
    <Container className="selected-filters">
      <Typography className="selected-filters__title" component="p" variant="h6">
        {title}
      </Typography>
      <Grid container spacing={1} alignItems="center">
        {data.map(item => {
          const chipProps = {
            label: item.name,
            clickable: true,
            color: 'primary',
            onDelete: onDelete(item),
          };

          if (!clickable) {
            delete chipProps.onDelete;
            delete chipProps.clickable;
          }

          return (
            <Grid item key={item.id}>
              <Chip {...chipProps} />
            </Grid>
          );
        })}
      </Grid>
    </Container>
  );
};

SelectedSection.defaultProps = {
  clickable: true,
  onDelete: () => {},
};

SelectedSection.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  clickable: PropTypes.bool,
  onDelete: PropTypes.func,
};

export default React.memo(SelectedSection);
